import React, { FC, memo } from 'react'
import {
    Answer,
    Container,
    ContentWrapper,
    CustomMarkdown,
    FAQItem,
    Question,
    SubtitleContainer,
    TitleContainer,
    TitleSubtitleWrapper,
} from './styles'
import { FAQTransport } from '../../../transports/region-landing-page-transport'
import { useTranslation } from '../../../hooks/locale'

interface FaqsProps {
    faqs: FAQTransport[]
    location: string
}

const FAQSection: FC<FaqsProps> = ({ faqs, location }) => {
    const { t } = useTranslation()
    const faqSectionSubtitle = `${t('faqSubTitle')} ${location}`

    return (
        <Container id="faqs">
            <TitleSubtitleWrapper>
                <TitleContainer>{t('faqsTitle')}</TitleContainer>
                <SubtitleContainer>{faqSectionSubtitle}</SubtitleContainer>
            </TitleSubtitleWrapper>
            <ContentWrapper>
                {faqs.map(
                    faq =>
                        faq.question &&
                        faq.answer && (
                            <FAQItem key={faq.question}>
                                <Question>{faq.question}</Question>
                                <Answer>
                                    <CustomMarkdown>{faq.answer}</CustomMarkdown>
                                </Answer>
                            </FAQItem>
                        ),
                )}
            </ContentWrapper>
        </Container>
    )
}

export default memo(FAQSection)
